import React from 'react';

export const ManageApp = (props) => {
    const { width, height, action } = props
    const fill = action ? "#202020" : "#7D86A9"
    // #7D86A9
    return (
        <svg width={width} height={height} viewBox="0 0 17 17" version="1.1" xmlns="http://www.w3.org/2000/svg" >

            <title>ic_manage_app</title>
            <desc>Created with Sketch.</desc>
            <g id="Web-Notification" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="01_Dashboard" transform="translate(-22.000000, -234.000000)" fill={fill} fillRule="nonzero">
                    <g id="sidemenu" transform="translate(0.000000, 70.000000)">
                        <g id="item" transform="translate(0.000000, 152.000000)">
                            <g id="ic_manage_app" transform="translate(22.000000, 12.000000)">
                                <polygon id="Shape" points="3.07833333 6.39018913 13.9371852 6.39018913 13.9371852 16.9785283 16.9917407 16.9785283 16.9917407 3.95272174 8.26585185 0 0.0237777778 3.95272174 0.0237777778 16.9785283 3.07833333 16.9785283"></polygon>
                                <rect id="Rectangle-path" x="6.33907407" y="14.9135457" width="1.92677778" height="1.65853478"></rect>
                                <rect id="Rectangle-path" x="8.70388889" y="14.9135457" width="1.92677778" height="1.65853478"></rect>
                                <rect id="Rectangle-path" x="3.97455556" y="14.9135457" width="1.92677778" height="1.65853478"></rect>
                                <rect id="Rectangle-path" x="6.33907407" y="12.6385761" width="1.92677778" height="1.65853478"></rect>
                                <rect id="Rectangle-path" x="3.97455556" y="12.6385761" width="1.92677778" height="1.65853478"></rect>
                                <rect id="Rectangle-path" x="8.70388889" y="12.6385761" width="1.92677778" height="1.65853478"></rect>
                                <polygon id="Rectangle-path" points="6.33907407 10.3639391 8.26585185 10.3639391 8.26585185 12.0224739 6.33907407 12.0224739"></polygon>
                                <polygon id="Rectangle-path" points="3.97455556 10.3639391 5.90133333 10.3639391 5.90133333 12.0224739 3.97455556 12.0224739"></polygon>
                                <rect id="Rectangle-path" x="11.0684074" y="14.9135457" width="1.92677778" height="1.65853478"></rect>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
}